/** 
 *   订单 API
 */
 import { get, post } from '@/untils/axios.js'


 //  实时订单列表
 export const order = params => get('/order/list', params)
 
 //  实时订单详情
 export const order_detail = (id,params) => get(`/order/list/details/${id}`,params)
 
 //  实时订单详情
 export const add_remarks = (id,params) => post(`/order/add-remarks/${id}`,params)

 // 打款接口
 export const payment_amount  = params => post(`/payment/amount`,params)
 
 //  修改自提时间
 export const pickup_time = (id,params) => get(`order/pickuptime/${id}`, params)
 
 //  实时订单 通知库房
 export const order_next = params => get(`/order/noticeout/${params}`)
 
 // 预售订单列表
 export const presellGoodsList = params => get(`/order/presale-list`, params)
 
 // 预售商品列表
 export const presaleGoodsList = params => get(`/order/presale-goods-list`, params)
 
 
 // 预售订单详情
 export const presellGoodsListDetail = params =>get(`/order/list/details/${params}`)
 
 //  售后列表
 export const aftersale = params => get('/aftersale/list', params)
 
 //  售后处理
 export const aftersale_handle = params => post('/aftersale/handle', params)
 
 // 线下门店下单
 
 // 添加商品
 export const orderGoodsAdd = params => post('/order/store-order/add-goods', params)
 // 删除商品
 export const orderGoodsDel = params => post('/order/store-order/del-goods', params)
 // 修改商品
 export const orderGoodsUpdate = params => post('/order/store-order/update-goods', params)
 // 商品列表
 export const orderGoodsList = params => get('/order/store-order/goods-list', params)
 // 计算价格
 export const orderGoodsPrice = params => post('/order/store-order/get-price', params)
 // 确认下单
 export const orderGoodsPlace = params => post('/order/store-order/place-order', params) 
 //搜索商品
 export const storeOrderSearch = params => get('/order/store-order/search-goods', params)
 